import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { CookieService } from 'ngx-cookie-service';
import { Guid } from 'guid-typescript';
import { B2cConfigService } from './b2c-config.service';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class SolLoginService {
  env = environment;
  private static readonly entryParamsKey = 'SolEntryParams';
  private static readonly signInParams = [
    'queryparamdata', 'subenv', 'state', 'error', 'error_description', 'code', 'session_state',
    'id_token', 'access_token', 'token_type', 'expires_in', 'nonce'
  ];

  constructor(
    private readonly oauthService: OAuthService,
    private readonly b2cConfig: B2cConfigService,
    private readonly cookieService: CookieService
  ) { }

  /** Switches back to the normal SCS B2C, for when the SOL sign-in is abandoned. */
  useScsSignIn(): void {
    this.b2cConfig.apply(this.oauthService, 'scs');
  }

  entryParams(): string {
    return sessionStorage.getItem(SolLoginService.entryParamsKey) || '';
  }


  campaignParams(queryString: string): string {
    const pairs = (queryString || '').replace(/^\?/, '').split('&').filter(pair => {
      const key = pair.split('=')[0].toLowerCase();
      return key && !SolLoginService.signInParams.includes(key);
    });
    return pairs.length ? '?' + pairs.join('&') : '';
  }

  startConsentSignIn(queryString: string): void {
    // Real campaign parameters replace what was stored; a bare return from B2C keeps what the first visit stored.
    const campaign = this.campaignParams(queryString);
    if (campaign) {
      localStorage.setItem('UtmParams', campaign);
      sessionStorage.setItem(SolLoginService.entryParamsKey, campaign);
      this.captureReturnXParams(campaign);
    }

    this.b2cConfig.apply(this.oauthService, 'sol');
    this.oauthService.redirectUri = globalThis.location.origin + '/scs-consent';
    this.oauthService.initLoginFlow(campaign || this.entryParams(), {
      submissionId: this.cookieService.get('submissionId') || '',
      ccAppUrl: globalThis.location.origin,
      submissionCode: Guid.create().toString(),
      instrumentationKey: this.env.appInsights.instrumentationKey
    });
  }

  async waitForAuthorizeEndpoint(timeoutMs = 10000): Promise<boolean> {
    const pollMs = 250;
    for (let waited = 0; waited < timeoutMs; waited += pollMs) {
      if (this.oauthService.loginUrl?.endsWith('authorize')) {
        return true;
      }
      await new Promise(resolve => setTimeout(resolve, pollMs));
    }
    return !!this.oauthService.loginUrl?.endsWith('authorize');
  }

  private captureReturnXParams(queryString: string): void {
    const params = new URLSearchParams(queryString.startsWith('?') ? queryString.substring(1) : queryString);
    const utmId = params.get('utm_id')?.trim().toLowerCase();
    if (utmId === 'returnx') {
      sessionStorage.setItem('utm_id', utmId);

      const offerId = params.get('offer_id');
      const trackId = params.get('track_id');
      if (offerId) {
        sessionStorage.setItem('offer_id', offerId);
      }
      if (trackId) {
        sessionStorage.setItem('track_id', trackId);
      }
    }
  }
}
